import { render, staticRenderFns } from "./SpatialDistribution.vue?vue&type=template&id=20c1ade8&scoped=true&"
import script from "./SpatialDistribution.vue?vue&type=script&lang=js&"
export * from "./SpatialDistribution.vue?vue&type=script&lang=js&"
import style0 from "./SpatialDistribution.vue?vue&type=style&index=0&id=20c1ade8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1ade8",
  null
  
)

export default component.exports